import { UserOutlined } from "@ant-design/icons";
import { Flex } from "antd";
import React from "react";
import { resolveImageUrl } from "../../utils/image";
import { neutral } from "../../theme/tokens";

export default function CustomerOption({ avatar, name, phone, email, customer_code, referral_code }) {
  return (
    <Flex align="center" gap={10} justify="flex-start">
      {avatar ? (
        <img
          style={{ width: 60, height: 60, borderRadius: 50 }}
          src={resolveImageUrl(avatar)}
          alt=""
        />
      ) : (
        <UserOutlined
          style={{
            fontSize: 20,
            color: "#fff",
            borderRadius: 50,
            background: "rgba(0, 0, 0, 0.25)",
            padding: 20,
          }}
        />
      )}
      <Flex vertical>
        <p style={{ fontWeight: 600 }}>{name} </p>
        <p style={{ margin: 0 }}>SĐT: {phone}</p>
        {customer_code && <p style={{ margin: 0, fontSize: "11px", color: neutral[500] }}>Mã KH: {customer_code}</p>}
        {referral_code && referral_code !== customer_code && (
          <p style={{ margin: 0, fontSize: "11px", color: neutral[500] }}>Mã GT: {referral_code}</p>
        )}
        {email && <p style={{ margin: 0 }}>{email}</p>}
      </Flex>
    </Flex>
  );
}
